import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Mail, MapPin, Phone, Leaf } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-gray-900 text-gray-200" data-id="element-237">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-238">
        {/* Main footer content */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 py-16" data-id="element-239">
          {/* Logo and About */}
          <div className="md:col-span-4" data-id="element-240">
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTr3OIOItvNmTn92A0WvwPYsp3--3wl0xZVhg&s" alt="Logo" className="h-8 w-auto mb-4" onError={e => {
            e.currentTarget.src = 'https://ui-avatars.com/api/?name=Shiriaka&background=e8f5e9&color=2e7d32&size=70&bold=true';
          }} data-id="element-241" />
            <p className="text-gray-400 mb-6" data-id="element-242">
              At Shiriaka Essentials, we harness the power of Kenya's rich
              botanical diversity to create premium quality essential oils that
              enhance wellbeing.
            </p>
            <div className="flex space-x-4" data-id="element-243">
              <a href="#" className="text-gray-400 hover:text-white" data-id="element-244">
                <Facebook size={20} data-id="element-245" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white" data-id="element-246">
                <Instagram size={20} data-id="element-247" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white" data-id="element-248">
                <Twitter size={20} data-id="element-249" />
              </a>
            </div>
          </div>
          {/* Quick Links */}
          <div className="md:col-span-2" data-id="element-250">
            <h3 className="text-lg font-semibold mb-4" data-id="element-251">Quick Links</h3>
            <ul className="space-y-2" data-id="element-252">
              <li data-id="element-253">
                <Link to="/" className="text-gray-400 hover:text-white" data-id="element-254">
                  Home
                </Link>
              </li>
              <li data-id="element-255">
                <Link to="/about" className="text-gray-400 hover:text-white" data-id="element-256">
                  About Us
                </Link>
              </li>
              <li data-id="element-257">
                <Link to="/products" className="text-gray-400 hover:text-white" data-id="element-258">
                  Shop
                </Link>
              </li>
              <li data-id="element-259">
                <Link to="/blog" className="text-gray-400 hover:text-white" data-id="element-260">
                  Blog
                </Link>
              </li>
              <li data-id="element-261">
                <Link to="/contact" className="text-gray-400 hover:text-white" data-id="element-262">
                  Contact
                </Link>
              </li>
              <li data-id="element-263">
                <Link to="/ria-skincare" className="text-gray-400 hover:text-white" data-id="element-264">
                  Ria Skincare
                </Link>
              </li>
            </ul>
          </div>
          {/* Products */}
          <div className="md:col-span-2" data-id="element-265">
            <h3 className="text-lg font-semibold mb-4" data-id="element-266">Products</h3>
            <ul className="space-y-2" data-id="element-267">
              <li data-id="element-268">
                <Link to="/category/single" className="text-gray-400 hover:text-white" data-id="element-269">
                  Single Oils
                </Link>
              </li>
              <li data-id="element-270">
                <Link to="/category/blend" className="text-gray-400 hover:text-white" data-id="element-271">
                  Oil Blends
                </Link>
              </li>
              <li data-id="element-272">
                <Link to="/category/diffuser" className="text-gray-400 hover:text-white" data-id="element-273">
                  Diffusers
                </Link>
              </li>
              <li data-id="element-274">
                <Link to="/category/carrier" className="text-gray-400 hover:text-white" data-id="element-275">
                  Carrier Oils
                </Link>
              </li>
            </ul>
          </div>
          {/* Contact Info */}
          <div className="md:col-span-4" data-id="element-276">
            <h3 className="text-lg font-semibold mb-4" data-id="element-277">Contact Info</h3>
            <ul className="space-y-4" data-id="element-278">
              <li className="flex items-center space-x-3" data-id="element-279">
                <MapPin size={20} className="text-gray-400" data-id="element-280" />
                <span className="text-gray-400" data-id="element-281">
                  123 Kenyatta Avenue, Nairobi, Kenya
                </span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-282">
                <Phone size={20} className="text-gray-400" data-id="element-283" />
                <span className="text-gray-400" data-id="element-284">+254 700 123 456</span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-285">
                <Mail size={20} className="text-gray-400" data-id="element-286" />
                <span className="text-gray-400" data-id="element-287">info@shiriakaoils.com</span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-288">
                <Leaf size={20} className="text-gray-400" data-id="element-289" />
                <span className="text-gray-400" data-id="element-290">100% Pure & Natural</span>
              </li>
            </ul>
          </div>
        </div>
        {/* Bottom Bar */}
        <div className="border-t border-gray-800 py-8 text-center" data-id="element-291">
          <p className="text-gray-400" data-id="element-292">
            &copy; {new Date().getFullYear()} Shiriaka Essentials. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;